// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_2z-1";
export var movingGradient = "_2z-4";
export var movingGradientBlock = "_2z-2";
export var skeleton = "_2z-0";
export var skeletonText = "_2z-3";